'use client';
import Link from 'next/link';
import { TypeContentTitleCom } from './types/home.type';
import Image from 'next/image';

export default function ContentBodyCom({
    data,
    center,
}: {
    data: TypeContentTitleCom;
    center?: boolean;
}) {
    const {
        slug,
        specialty_slug,
        icon,
        title,
        full_name,
        // url
    } = data;

    // let formattedUrl = url.substring(0, url.lastIndexOf("/"));
    // formattedUrl = formattedUrl.substring(formattedUrl.lastIndexOf("/") + 1);
    return (
        <Link
            href={
                center
                    ? `/centers/specialty/${slug}`
                    : specialty_slug && specialty_slug === slug
                    ? `/doctors/specialty/${slug}`
                    : `/specialty/${slug}`
            }
            prefetch={false}
            className="flex justify-center smp:!flex-row flex-col-reverse smp:!justify-between min-w-[200px] max-w-[200px] smp:min-w-[250px] smp:max-w-[250px] items-center smp:!items-end rounded-3xl border border-transparent hover:!bg-lavender transition-colors hover:!border-blue hover:!text-blue text-white bg-blue smp:!pt-4 pt-1 pb-2 smp:!pb-4 px-4 gap-3"
        >
            <p className="font-semibold max-w-[140px] truncate">
                {full_name ? full_name : title}
            </p>

            <div className="relative smp:!w-max w-full">
                <Image
                    src={icon ? process.env.NEXT_PUBLIC_STATIC_URL + icon : ''}
                    width={1000}
                    height={1000}
                    alt={
                        full_name
                            ? `${full_name}-درمان شیرین`
                            : `${title}-درمان شیرین`
                    }
                    // className="!min-w-[120px] absolute left-0 h-[110px] bottom-0 rounded-full"
                    className="smp:!min-w-[80px] max-w-[68px] min-w-[68px] smp:!max-w-[80px] border border-blue absolute left-1/2 smp:!-translate-x-0 -translate-x-1/2 smp:!left-0 h-[68px] smp:!h-[80px] mx-auto -bottom-1 smp:!bottom-0 rounded-full"
                />
            </div>
        </Link>
    );
}
